import request from "@/utils/request";

export function getAllCycles(sath) {
  return request({
    url: "/data/forall",
    method: "post",
    data: {
      Sath: sath,
    },
  });
}

export function getOpenCycles() {
  return request({
    url: "/amoozesh/register/opencycles",
    method: "post",
  });
}
export function registerClasses(classIds, cycleId) {
  return request({
    url: "/amoozesh/register/applyCycles",
    method: "post",
    data: { classIds: classIds, cycleID: cycleId },
  });
}

export function getExams() {
  return request({
    url: "amoozesh/kartexam",
    method: "post",
  });
}

export function downloadKartExam(cycleId) {
  return request({
    url: "/amoozesh/downloadKartExam",
    method: "post",

    data: { ID: cycleId },
  });
}
